import { IconButton } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "./Listwidget.css";
import React, { useState, useEffect } from "react";
import { ReactComponent as DeleteSvg } from "../../../components/icon/delete.svg";
import { ReactComponent as EditSvg } from "../../../components/icon/edit.svg";
import { ReactComponent as SearchSvg } from "../../../components/icon/search.svg";
import { ReactComponent as FilterStack } from "../../../components/icon/filterstack.svg";
import WidgetPreview from "./WidgetPreview";
import DeletePrompt from "../../presentation/common-component/DeletePrompt";
import Breadcrumb from "../../../components/bootstrap/Breadcrumb";
import SubHeader, {
  SubHeaderLeft,
  SubHeaderRight,
} from "../../../layout/SubHeader/SubHeader";
import Icon from "../../../components/icon/Icon";
import Input from "../../../components/bootstrap/forms/Input";
import Dropdown, {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "../../../components/bootstrap/Dropdown";
import Button from "../../../components/bootstrap/Button";
import Card, { CardBody, CardHeader } from "../../../components/bootstrap/Card";
import FilterMenu from "../../../components/FilterMenu";
import SearchInput from "../../../components/SearchInput";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../../components/ToastComponent";
import ToastComponent from "../../../components/ToastComponent";

interface WidgetDetail {
  id: number;
  name: string;
}

interface WidgetListProps {
  type: "add" | "delete";
  detail: WidgetDetail[];
  newId: number;
}

interface ListWidgetV2Props {
  widgetList: WidgetListProps;
  setWidgetList: React.Dispatch<React.SetStateAction<WidgetListProps>>;
}

function ListWidget(this: any, { widgetList, setWidgetList }: any) {
  // console.log(props);
  const vyu_api_url = process.env.REACT_APP_VYU_API_URL;
  const vyu_service_url = process.env.REACT_APP_VYU_SERVICE_URL;
  type WIDGET = {
    createUser: string;
    createDate: string;
    updateUser: string | null;
    updateTime: string | null;
    id: number;
    name: string;
    queryId: number;
    viewTypeId: any;
    roles: any[];
    groups: any[];
  };
  const [rowDataToBeDeleted, setRowDataToBeDeleted] = React.useState<any>();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [rowHeight, setRowHeight] = useState<number>(0);
  const [searchedString, setSearchedString] = React.useState("");
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [filterValue, setFilterValue] = useState<string>("");
  const open = Boolean(anchorEl);
  const token = localStorage.getItem("token");
  const [gridApi, setGridApi] = useState<any>(null);
  const Buttons: (params: any) => React.JSX.Element = (
    params: any
  ): React.JSX.Element => (
    <div className="items-justify-center justify-center w-fit">
      <IconButton
        // className="w-10"
        onClick={() => edit(params)}
      >
        <EditSvg />
      </IconButton>
      <> </>
      <IconButton onClick={() => deleteWidget(params)}>
        <DeleteSvg className="" />
      </IconButton>

      <> </>
      <Button
        className="h-9 bg-pink-400 preview-bttn"
        // variant="contained"
        onClick={() => preview(params)}
      >
        Preview
      </Button>
    </div>
  );
  const [openPreviewDialog, setOpenPreviewDialog] = React.useState(false);
  const [openPreviewDeleteDialog, setOpenPreviewDeleteDialog] =
    React.useState(false);
  const [rows, setRows] = React.useState<any[]>([{ id: 1 }]);
  const [duplicateRows, setDuplicateRows] = React.useState<any[]>([{ id: 1 }]);
  const [columns, setColumns]: any[] = React.useState<any[]>([
    {
      field: "id",
      headerName: "ID",
      width: 100,
      filter: "agNumberColumnFilter",
      resizable: true,
      hide: true,
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "first-column",
    },
    {
      field: "queryId",
      headerName: "Query",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "other-column",
    },
    {
      field: "parentWidget",
      headerName: "Parent Widget",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "other-column",
    },
    {
      field: "viewTypeId.name",
      headerName: "View Type",
      width: 200,
      filter: "agTextColumnFilter",
      resizable: true,
      flex: 15,
      cellClass: "other-column",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 400,
      cellRenderer: Buttons,
      cellRendererParams: {
        edit: edit.bind(this),
        deleteWidget: deleteWidget.bind(this),
        preview: preview.bind(this),
      },
      resizable: true,
      flex: 25,
      cellClass: "other-column",
    },
  ]);
  const [WidgetData, setWidgetData] = React.useState<any>({
    viewType: "Pie Chart",
    WidgetData: null,
  });
  const [selectedFilter, setSelectedFilter] = React.useState<string>("name");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const apiCallToGetAllWidgets = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${vyu_api_url}/widget/getAllWidgetForUser`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data || !data.obj || !Array.isArray(data.obj)) {
        throw new Error('Invalid data format received from server');
      }

      const dataToShow = data.obj.map((item: any) => {
        if (!item || !item.queryId) {
          console.warn('Invalid widget item found:', item);
          return null;
        }
        return {
          ...item,
          queryId: item.queryId.name || 'N/A',
          queryObj: item.queryId,
          parentWidget: item.parentWidget?.name || null,
        };
      }).filter(Boolean); // Remove any null items

      setRows(dataToShow);
      setDuplicateRows(dataToShow);
    } catch (error) {
      console.error('Error fetching widgets:', error);
      handleError('Failed to fetch widgets. Please try again later.');
      setRows([]);
      setDuplicateRows([]);
    } finally {
      setIsLoading(false);
    }
  };
  const calculateRowHeight = () => {
    const vh = window.innerHeight / 100;
    return 6 * vh;
  };
  useEffect(() => {
    const updateRowHeight = () => setRowHeight(calculateRowHeight());
    updateRowHeight();
    window.addEventListener("resize", updateRowHeight);

    return () => window.removeEventListener("resize", updateRowHeight);
  }, []);
  React.useEffect(() => {
    apiCallToGetAllWidgets();
  }, []);
  console.log(rows);
  const deleteWidgetApiCall = async (param: any, cascadeDelete: boolean) => {
    console.log(param);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${vyu_api_url}/widget/cascadeDeleteById?id=${param.data.id}&cascadeDelete=${cascadeDelete}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      handleSuccess(data.message);
      if (response.status === 200) {
        // setRows((prev) => prev.filter((item) => item.id !== param.data.id));
        apiCallToGetAllWidgets();
      }
    } catch (e) {
      handleError("error occured....");
      console.log("error occured ", e);
    }
  };
  const handleWarning = (message: string) => {
    showWarningToast(message);
  };
  const handleSuccess = (message: string) => {
    showSuccessToast(message);
  };
  const handleError = (message: string) => {
    showErrorToast(message);
  };
  function edit(params: any) {
    console.log(params);
    let widgetDetail: WidgetDetail = {
      id: params.data.id,
      name: params.data.name,
    };
    const isPresent = widgetList.detail.some(
      (item: WidgetDetail) => item.id === widgetDetail.id
    );
    setWidgetList({
      type: "add",
      detail: isPresent
        ? widgetList.detail
        : [...widgetList.detail, widgetDetail],
      newId: params.data.id,
    });
  }

  function deleteWidget(data: any) {
    setOpenPreviewDeleteDialog(true);
    setRowDataToBeDeleted(data);
    // deleteWidgetApiCall(data);
    // console.log(data)
  }
  function deleteWidgetOnConfirmation(
    data: any,
    confirmDelete: boolean = false
  ) {
    deleteWidgetApiCall(data, confirmDelete);
  }
  function preview(data: any) {
    console.log(data);
    setOpenPreviewDialog(true);
    setWidgetData({
      viewType: data.data.viewTypeId.name,
      WidgetData: data.data,
    });

    console.log({ viewType: data.data.viewTypeId.name, WidgetData: data.data });
  }

  const filters: any = {
    Name: "name",
    Query: "query",
    ViewType: "viewType",
    ParentWidget: "parentWidget",
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Remove a specific filter
  const handleRemoveFilter = (filterKey: string) => {
    setSelectedFilters((prev) => prev.filter((item) => item !== filterKey));
  };

  // Function to add/remove filters
  const toggleFilter = (filter: string) => {
    setSelectedFilters(
      (prevFilters) =>
        prevFilters.includes(filter)
          ? prevFilters.filter((f) => f !== filter) // Remove if already selected
          : [...prevFilters, filter] // Add if not selected
    );
  };
  // Function to apply filters to the row data
  // const applyFilters = (value: string) => {
  //   const lowerCaseValue = value.toLowerCase();

  //   const filteredRows = duplicateRows.filter((item) =>
  //     selectedFilters.some((filter) => {
  //       // Special handling for viewTypeId
  //       if (filter === "viewTypeId") {
  //         // Check if viewTypeId exists and if the name property starts with the value
  //         const viewType = item[filter];
  //         return viewType?.name?.toLowerCase().startsWith(lowerCaseValue);
  //       }
  //       const cellValue = String(item[filter] ?? "").toLowerCase();
  //       return cellValue.includes(lowerCaseValue);
  //     })
  //   );
  //   setRows(filteredRows);
  // };

  // Function to apply filters to the row data
  const applyFilters = async (searchTerm: string) => {
    if (gridApi) gridApi.showLoadingOverlay();
    try {
      // Construct URL with query parameters
      const params = new URLSearchParams({
        widget: searchTerm,
        filter: selectedFilters.join(","), // Join filters array as a comma-separated string
      });

      const response = await fetch(
        `${vyu_api_url}/filter/query/searchWidgets?${params}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        console.error("Server error:", response.status, response.statusText);
        return;
      }

      const data = await response.json();
      console.log("This is inside api");
      const dataToShow = data.obj.map((item: any) => {
        return {
          ...item,
          queryId: item.queryId.name,
          queryObj: item.queryId,
          parentWidget:
            item.parentWidget !== null ? item.parentWidget.name : null,
        };
      });
      // Check if the response format includes 'obj' and if 'obj' is not empty
      if (data.status === "Success" && data.obj) {
        if (data.obj.length > 0) {
          setRows(dataToShow); // Set rows with the content of 'obj' array
        } else {
          console.log("No results found.");
          setRows([]); // Set rows to an empty array if 'obj' is empty
        }
      } else {
        setRows([]); // Clear rows if the structure is unexpected
      }
    } catch (error) {
      console.error(
        "Error fetching data:",
        error,
        `${vyu_api_url}/filter/query/searchQueries`
      );
    } finally {
      if (gridApi) gridApi.hideOverlay();
    }
  };

  // Modified search filter function
  const handleSearchFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFilterValue(value);
    // If no filters are selected and input is not empty, apply the search value across all columns
    // if (selectedFilters.length === 0 && value !== "") {
    //   const filteredRows = duplicateRows.filter((item) => {
    //     return Object.keys(item).some((key) => {
    //       const itemValue = item[key];
    //       return (
    //         typeof itemValue === "string" &&
    //         itemValue.toLowerCase().includes(value.toLowerCase())
    //       );
    //     });
    //   });
    //   setRows(filteredRows);
    //   return;
    // }
    // If input is empty, apply all selected filters
    if (!value) {
      setRows(duplicateRows);
      return;
    } 
     if (value.length >= 2) {
       applyFilters(value);
     } else {
       // Option 1: Reset to original data
       setRows(duplicateRows);
       // Option 2: Do nothing (keep previous results)
       // return;
     }
  };

  const getRowStyle = (params: any) => {
    if (params.node.rowIndex % 2 !== 0) {
      return { background: "#F5F7F8", height: "10px", display: "flex" };
    } else {
      return { background: "#FCFCFC", height: "10px", display: "flex" };
    }
  };
  return (
    <>
      <Breadcrumb
        list={[
          { title: "Widgets", to: "" },
          { title: "List", to: "" },
        ]}
      />
      <div style={{ paddingLeft: "4vh" }}>
        <SearchInput
          filterValue={filterValue}
          onSearchChange={handleSearchFilter}
          selectedFilters={selectedFilters}
        />
        <FilterMenu
          filters={filters}
          selectedFilters={selectedFilters}
          onToggleFilter={toggleFilter}
          onRemoveFilter={handleRemoveFilter}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onOpen={handleClick}
        />
      </div>
      <Card className="grid-div">
        <CardBody>
          <AgGridReact
            className="ag-theme-quartz ag-theme-quartz-listWidget"
            rowData={rows}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={false}
            getRowStyle={getRowStyle}
            onGridReady={(params) => setGridApi(params.api)}
          />
        </CardBody>
      </Card>
      <WidgetPreview
        open={openPreviewDialog}
        onclose={() => setOpenPreviewDialog(false)}
        data={WidgetData}
      />
      <DeletePrompt
        component={"Widget"}
        dataToBeDeleted={rowDataToBeDeleted}
        open={openPreviewDeleteDialog}
        onclose={() => setOpenPreviewDeleteDialog(false)}
        confirmCallBack={deleteWidgetOnConfirmation}
        data={WidgetData}
      />
      {/* <div style={{paddingLeft:'2vh'}}>
      <WidgetPreview
        open={openPreviewDialog}
        onclose={() => setOpenPreviewDialog(false)}
        data={WidgetData}
      />
      <DeletePrompt
        component={'Widget'}
        dataToBeDeleted={rowDataToBeDeleted}
        open={openPreviewDeleteDialog}
        onclose={() => setOpenPreviewDeleteDialog(false)}
        confrimCallBack={deleteWidgetOnConfirmation}
        data={WidgetData}
      /> 
      <div className="font-semibold  text-3xl  italic items-justify-center">
        <h1 className="font-semibold  text-3xl pb-2 italic  items-center ">
          <span
            style={{
              color: "#201C34",
              // fontFamily: "SF Pro Display",
              fontSize: "30px",
              fontStyle: "italic",
              fontWeight: 600,
              lineHeight: "normal",
            }}
          >
            Widgets
          </span>
        </h1>
      </div>
      <TextField
        sx={{
          flex: "flex",
          borderRadius: 2,
          border: "1px  rgba(95, 143, 222, 0.50) solid",
          height: "fit",
          width: "91.5%",
          padding: 0,
          paddingBottom: 0,
          alignSelf: "center",
          marginRight: "1%",
          marginLeft: "0%",
          marginBottom: "2%",
          borderColor: "blue",
          fontStyle: "italic",
        }}
        size="small"
        variant="outlined"
        onChange={widgetSearchFilter}
        placeholder={`Search by ${selectedFilter}...`}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchSvg />
            </InputAdornment>
          ),
        }}
      ></TextField>
      <IconButton
            style={{
              height: 37,
              padding: 0,
              paddingBottom: 0,
            }}
            onClick={handleClick}
          >
            <FilterStack height={39} width={90} />
          </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          disablePadding: true,
          variant:"selectedMenu"
             }}
          style={{
            // backgroundColor: "#F3F2FF",
            padding:'0px 0px'
          }}
        >
          <ul style={{
            backgroundColor: "#F3F2FF",
            // paddingTop:0,
            // paddingBottom:0
          }}>
          {Object.keys(filters).map((filter: any) => (
            <MenuItem
              className="italic"
              key={filter}
              value={filters[filter]}
              onClick={handleChange(filters[filter])}
              style={{
            backgroundColor: "#F3F2FF",
          }}
            >
              {filter}
            </MenuItem>
            
          ))}
          </ul>
        </Menu>
      </div>
      <div
        style={{
          // height: 540,
          width: "100%",
          fontSize: 14,
          fontStyle: "italic",
          // display: "flex",
          // backgroundColor: 'red',
        }}
      >
        <div className="grid-div">
          <AgGridReact
            className="ag-theme-quartz ag-theme-quartz-listWidget"
            rowData={rows}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={false}
            rowHeight={rowHeight} 
            getRowStyle={getRowStyle}
          />
        </div>
      </div> */}
      <ToastComponent />
    </>
  );
}

export default ListWidget;
